module.exports = __webpack_public_path__ + "images/2-olde9c046a220b00bf23471a2af03b4b561.svg";